import type {
  UnifiedProduct,
  UnifiedProductCustomAttribute,
  UnifiedProductTypedAttributeValue,
} from '../types/UnifiedProduct';

export const buildCustomAttribute = (
  key: string,
  value: UnifiedProductTypedAttributeValue,
): UnifiedProductCustomAttribute => ({ key, value, attributeType: null });

export const unifiedProduct: UnifiedProduct = {
  attributes: {
    highlyRated: false,
    starBrand: true,
  },
  customAttributes: [
    buildCustomAttribute('dominant_colour', { value: 'Silver' }),
    buildCustomAttribute('material', {
      values: ['Crystal (Swarovski)', 'Gold Plated (14Ct)', 'Pearl', 'Silver Plated'],
    }),
    buildCustomAttribute('pim_made_in_britain', { value: 'Made In Britain' }),
    buildCustomAttribute('low_commitment_product_fl', { boolValue: false }),
    buildCustomAttribute('compliance_category', {
      value: 'None - No Compliance Category Applies',
    }),
    buildCustomAttribute('delivery_cost', { numValue: 0 }),
    buildCustomAttribute('product_features', { values: ['Made to Order', 'Personalised'] }),
    buildCustomAttribute('pim_product_type', {
      values: ['jewellery', 'jewellery > body jewellery', 'jewellery > body jewellery > anklets'],
    }),
    buildCustomAttribute('product_type_level_1', { value: 'jewellery' }),
    buildCustomAttribute('product_type_level_2', { value: 'body jewellery' }),
    buildCustomAttribute('product_type_level_3', { value: 'anklets' }),
    buildCustomAttribute('returnable', { value: 'Returnable' }),
  ],
};
